module.exports = __webpack_public_path__ + "static/img/vote_tip.515b6b6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/vote_tip.png
// module id = YsAD
// module chunks = 1